export const KeyEvents = {
  Reject: 'invoice.rejected',
  Created: 'invoice.created',
  Paid: 'invoice.paid',
  CratedPartial: 'invoice.create_partial',
  PaidPartial: 'invoice.paid_partial'
}
